import { UseQueryResult } from '@tanstack/react-query';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { createGridOverlays } from '../../../../grid-overlay/no-data-overlay-helpers';
import { LabelSyncUserStatus } from '../../shared/types';
import SharedGpanelGrid from '../../shared/components/shared-gpanel-grid';
import GpanelContactsGridToolbar from '../gpanel-contacts/gpanel-contacts-grid/gpanel-contacts-grid-toolbar';
import { getDateTimeString } from '../../shared/utils';
import SharedDataGridClient from '../../../../../shared/shared-data-grid-client';
import { useToolbar } from '../../../../../shared/shared-data-grid-toolbar-helper';
import Sync from '@mui/icons-material/Sync';

export default function GpanelContactsSyncUsersStatusPage({
  query,
  title,
}: {
  query: UseQueryResult<LabelSyncUserStatus[], Error>;
  title: string;
}) {
  const columnDefs = useMemo<GridColDef<LabelSyncUserStatus>[]>(
    () => [
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
        valueGetter: (_value, row) => {
          return row.userEmail ?? '';
        },
      },
      {
        field: 'error',
        headerName: 'Last Error',
        flex: 1,
        valueGetter: (_value, row) => {
          return row.error ?? '';
        },
      },
      {
        field: 'createdTime',
        headerName: 'Google Label Creation Time',
        flex: 1,
        valueGetter: (value: number) => {
          const date = new Date(value);
          if (value === 0) {
            return null;
          } else {
            return date;
          }
        },
        valueFormatter: (params: Date) => {
          return getDateTimeString(params);
        },
      },
    ],
    []
  );

  const toolbarProps = useMemo(
    () => ({
      isLoading: query.isFetching,
      onRefresh: () => query.refetch(),
      title,
      noSharedGridState: true,
      selection: [],
    }),
    [query, title]
  );
  return (
    <>
      <SharedGpanelGrid>
        <SharedDataGridClient
          columns={columnDefs}
          rows={query.data || []}
          loading={query.isFetching}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          pagination
          pageSizeOptions={[25, 50, 100]}
          defaultGridState={{
            pagination: { paginationModel: { pageSize: 25, page: 0 } },
          }}
          slots={{
            toolbar: useToolbar(GpanelContactsGridToolbar, toolbarProps),
            ...createGridOverlays(
              'Destination User Status',
              <Sync />,
              `There may be no users in the ${title}.`,
              'No Users Found'
            ),
          }}
          getRowHeight={() => 'auto'}
          sx={{
            '& .MuiDataGrid-cell': {
              alignContent: 'center',
              alignItems: 'center',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            },
            '& .MuiDataGrid-row': {
              alignItems: 'stretch',
              cursor: 'pointer',
            },
            '&.MuiDataGrid-root': { border: 'none' },
            '&.MuiDataGrid-root .MuiDataGrid-container--top [role=row]': {
              backgroundColor: (theme) => theme.palette.background.paper,
            },
          }}
        />
      </SharedGpanelGrid>
    </>
  );
}
